export class ConfigLine {
}
export const getAuthor = (value) => value >> 12;
export function decodeArguments(s) {
    const cleaned = s
        .replace(/\\'/g, '\u030A')
        .replace(/"/g, '\\"')
        .replace(/'/g, '"')
        .replace(/\u030A/g, "'");
    return JSON.parse('[' + cleaned + ']');
}
export function encodeArguments(args) {
    return JSON.stringify(args)
        .replace(/\\"/g, '\u030A')
        .replace(/'/g, "\\'")
        .replace(/"/g, "'")
        .replace(/\u030A/g, '"')
        .slice(1, -1);
}
export class ObjectLine extends ConfigLine {
    objectId;
    subtype;
    args;
    constructor(objectId, subtype, args) {
        super();
        this.objectId = objectId;
        this.subtype = subtype;
        this.args = args;
    }
    toString() {
        return `#Z${this.objectId}=${encodeArguments([
            this.subtype,
            ...(this.args ?? []),
        ])}`;
    }
}
